import {
  getAllOptions,
  getBanks,
  getCustomerOptions,
  getCustomerOptionsEmail,
  getCustomerOptionsPhone,
  getGlobalOptions,
  getNationalityOption
} from '@/api/common'
import {getSMEOption} from '@api/sme'
import {getNewSMEOption} from '@api/new_sme'
import {getCarClassOption} from '@api/privateCarList'

const SET_PRODUCT_ID = 'SET_PRODUCT_ID'
const SET_CAR_CLASS_ID = 'SET_CAR_CLASS_ID'
const SET_ALL_OPTIONS = 'SET_ALL_OPTIONS'
const SET_GLOBAL_OPTIONS = 'SET_GLOBAL_OPTIONS'
const SET_CUSTOMER_OPTIONS = 'SET_CUSTOMER_OPTIONS'
const SET_CUSTOMER_OPTIONS_PHONE = 'SET_CUSTOMER_OPTIONS_PHONE'
const SET_CUSTOMER_OPTIONS_EMAIL = 'SET_CUSTOMER_OPTIONS_EMAIL'
const SET_CUSTOMER_OPTIONS_USER = 'SET_CUSTOMER_OPTIONS_USER'
const SET_BANK_LIST = 'SET_BANK_LIST'
const SET_NATIONALITY_OPTIONS = 'SET_NATIONALITY_OPTIONS'
const SET_SPECIAL_OPTIONS = 'SET_SPECIAL_OPTIONS'
const SET_SME_OPTIONS = 'SET_SME_OPTIONS'
const SET_CAR_CLASS_OPTIONS = 'SET_CAR_CLASS_OPTIONS'
const SET_NEW_SME_OPTIONS = 'SET_NEW_SME_OPTIONS'

const state = {
  productId: 11,
  allOptions: null, // 電單車 - 14
  allOptions11: null, // 私家車 - 11
  allOptions12: null, // 商用車 - 12
  allOptions13: null, // 试用车 - 13
  allOptions15: null, // 北上 - 15
  allOptions21: null, // housemaid
  allOptions22: null, // Working
  allOptions23: null, // 旅游
  allOptions24: null, // 室外裝飾
  allOptions25: null, // 海外留學
  allOptions26: null, // 家居
  allOptions29: null, // fire
  allOptions27: null, // personal
  allOptions31: null, // pet
  globalOptions: null,
  customerOptions: null,
  customerOptionsUser:null,
  customerOptionsPhone: null,
  customerOptionsEmail: null,
  bankList:null,
  nationalityOptions: [], // 國籍選項
  specialOptions: {}, //存放指定的options
  smeOptions81:{},//catering
  smeOptions82:{},//Pure Office
  smeOptions83:{},//Retail Shop
  smeOptions84:{},//Beauty Center
  smeOptions85:{},//Education Center
  smeOptions86:{},//Hair Salon
  smeOptions88:{},//Medical Center
  newSMEOptions:{},
  carClassId:null,
  carClassOption:null
}

const mutations = {
  [SET_NEW_SME_OPTIONS]: (state, value) => {
    state.newSMEOptions = value
  },
  [SET_CAR_CLASS_OPTIONS]: (state, value) => {
    state.carClassOption = value
  },
  [SET_ALL_OPTIONS]: (state, data) => {
    const { class_id, options } = data
    if(class_id === 14) {
      state.allOptions = options
    } else {
      state[`allOptions${class_id}`] = options
    }
  },
  [SET_GLOBAL_OPTIONS]: (state, value) => {
    state.globalOptions = value
  },
  [SET_BANK_LIST]: (state, value) => {
    state.bankList = value
  },
  [SET_CUSTOMER_OPTIONS]: (state, value) => {
    state.customerOptions = value
  },
  [SET_PRODUCT_ID]: (state, value) => {
    state.productId = value
  },
  [SET_CAR_CLASS_ID]: (state, value) => {
    state.carClassId = value
  },
  [SET_CUSTOMER_OPTIONS_PHONE]: (state, value) => {
    state.customerOptionsPhone = value
  },
  [SET_CUSTOMER_OPTIONS_EMAIL]: (state, value) => {
    state.customerOptionsEmail = value
  },
  [SET_CUSTOMER_OPTIONS_USER]: (state, value) => {
    state.customerOptionsUser = value
  },
  [SET_NATIONALITY_OPTIONS]: (state, value) => {
    state.nationalityOptions = value
  },
  [SET_SPECIAL_OPTIONS]: (state, value) => {
    state.specialOptions = {...state.specialOptions,...value}
    // Object.assign(state.specialOptions, value)
  },
  [SET_SME_OPTIONS]: (state, data) => {
    const { product_id, options } = data
    state[`smeOptions${product_id}`] = options
  },
}

const actions = {
  setCarClassOptions({ commit }, val) {
    commit(SET_CAR_CLASS_OPTIONS, val)
  },
  setSMEOptions({ commit }, val) {
    commit(SET_SME_OPTIONS, val)
  },
  setProductId({ commit }, val) {
    console.log(val, '產品')
    commit(SET_PRODUCT_ID, val)
  },
  setCarClassId({ commit }, val) {
    console.log(val, '產品')
    commit(SET_CAR_CLASS_ID, val)
  },
  setAllOptions({ commit }, val) {
    commit(SET_ALL_OPTIONS, val)
  },
  setGlobalOptions({ commit }, val) {
    commit(SET_GLOBAL_OPTIONS, val)
  },
  // 檢查是否有遺漏的 options 數據未獲取成功，重新請求一次
  checkOptionsData({ state, dispatch  }) {
    // 全局數據
    if(!state.globalOptions) {
      dispatch('updateGlobalOptions')
    }
    // 類型數據
    const classList = [11, 12, 14,13, 21, 22, 23, 24, 25, 26,29,27]
    classList.some(classId => {
      // 電單車存儲方式不一樣，單獨區分
      if(classId === 14 && !state.allOptions) {
        dispatch('updateAllOptions')
      }
      if(classId !== 14 && !state[`allOptions${classId}`]) {
        dispatch('updateAllOptions', classId)
      }
    })
    const smeProductList = [81,82,83,84,85,86,88]
    smeProductList.some(smeProductId => {
      if(!state[`smeOptions${smeProductId}`]) {
        dispatch('updateSMEOptions', smeProductId)
      }
    })
    const specialOptionList = ['marketing_data', 'source', 'quote_tag', 'renew_product_type', 'ticket_class_type','lecture_session','verify_type']
    specialOptionList.some(key => {
      if(!state.specialOptions[key]) {
        dispatch('setSpecialOptions', key)
      }
    })
  },
  updateAllOptions({ commit }, val = 14) {
    return new Promise((resolve, reject) => {
      getAllOptions({
        class_id: val,
        hideLoading: true
      }).then(res => {
        const { data } = res
        commit(SET_ALL_OPTIONS, {
          class_id: val,
          options: data
        })
        if(val === 14) {
          sessionStorage.setItem('ALL_OPTIONS', JSON.stringify(data))
        } else {
          sessionStorage.setItem(`ALL_OPTIONS_${val}`, JSON.stringify(data))
        }
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  updateExtraOptions({ commit }, val) {
    return new Promise((resolve, reject) => {
      getAllOptions({
        ...val,
        hideLoading: true
      }).then(res => {
        const { data } = res
        commit(SET_ALL_OPTIONS, {
          class_id: val.class_id,
          options: data
        })
        if(val === 14) {
          sessionStorage.setItem('ALL_OPTIONS', JSON.stringify(data))
        } else {
          sessionStorage.setItem(`ALL_OPTIONS_${val}`, JSON.stringify(data))
        }
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  updateGlobalOptions({ commit }) {
    return new Promise((resolve, reject) => {
      getGlobalOptions({
        hideLoading: true
      }).then(res => {
        let { data } = res
        // 處理數據
        // const resultData = handlerOptionsData(data)
        commit(SET_GLOBAL_OPTIONS, data)
        sessionStorage.setItem('GLOBAL_OPTIONS', JSON.stringify(data))
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  setSpecialOptions({ commit }, val) {
    return new Promise((resolve, reject) => {
      getGlobalOptions({
        options_name: val,
        hideLoading: true
      }).then(res => {
        let { data } = res
        commit(SET_SPECIAL_OPTIONS, data)
        let spec = JSON.parse(sessionStorage.getItem('SPECIAL_OPTIONS')) || {}
        Object.keys(data).forEach(key => {
          spec[key] = data[key]
        })
        sessionStorage.setItem('SPECIAL_OPTIONS', JSON.stringify(spec))
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  updateCustomerOptions({ commit }) {
    return new Promise((resolve, reject) => {
      getCustomerOptions({
        hideLoading: true
      }).then(res => {
        let { data } = res
        commit(SET_CUSTOMER_OPTIONS, data)
        sessionStorage.setItem('CUSTOMER_OPTIONS', JSON.stringify(data))
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  getCustomerOptionsPhone({ commit },val,type) {
    return new Promise((resolve, reject) => {
      getCustomerOptionsPhone({
        hideLoading: true,
        search:val
      }).then(res => {
        let { data } = res
        commit(SET_CUSTOMER_OPTIONS_PHONE, data)
        resolve(res)
        // sessionStorage.setItem('CUSTOMER_OPTIONS', JSON.stringify(data))

      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  getCustomerOptionsEmail({ commit },val,type) {
    return new Promise((resolve, reject) => {
      getCustomerOptionsEmail({
        hideLoading: true,
        search:val
      }).then(res => {
        let { data } = res
        commit(SET_CUSTOMER_OPTIONS_EMAIL, data)
        resolve(res)
        // sessionStorage.setItem('CUSTOMER_OPTIONS', JSON.stringify(data))

      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  getCustomerOptionsUser({ commit },val, type) {
    return new Promise((resolve, reject) => {
      getCustomerOptions({
        hideLoading: true,
        search:val
      }).then(res => {
        let { data } = res
        commit(SET_CUSTOMER_OPTIONS_USER, data)
        resolve(res)
        // sessionStorage.setItem('CUSTOMER_OPTIONS', JSON.stringify(data))

      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  setCustomerOptionNUll({ commit }) {
    commit(SET_CUSTOMER_OPTIONS_PHONE, null)
    commit(SET_CUSTOMER_OPTIONS_USER, null)
    commit(SET_CUSTOMER_OPTIONS_EMAIL, null)
  },
  getBankList({ commit },val,type) {
    return new Promise((resolve, reject) => {
      getBanks({
        hideLoading: true,
        search:val
      }).then(res => {
        let { data } = res
        commit(SET_BANK_LIST, data)
        resolve(res)
        // sessionStorage.setItem('CUSTOMER_OPTIONS', JSON.stringify(data))

      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  updateNationalityOptions({ commit }, id) {
    return new Promise((resolve, reject) => {
      getNationalityOption({
        nationality_id: id,
        hideLoading: true
      }).then(res => {
        const { data } = res
        commit(SET_NATIONALITY_OPTIONS, data)
        resolve(res)
      }).catch(e => {
        console.log(e)
        reject(e)
      })
    })
  },

  updateSMEOptions({ commit }, val = 81) {
    return new Promise((resolve, reject) => {
      getSMEOption({
        hideLoading: true
      },val).then(res => {
        const { data } = res
        commit(SET_SME_OPTIONS, {
          product_id: val,
          options: data
        })
        sessionStorage.setItem(`SME_OPTIONS_${val}`, JSON.stringify(data))
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  updateNewSMEOptions({ commit }) {
    return new Promise((resolve, reject) => {
      getNewSMEOption({
        hideLoading: true
      }).then(res => {
        const { data } = res
        commit(SET_NEW_SME_OPTIONS, {
          ...data
        })
        sessionStorage.setItem('SET_NEW_SME_OPTIONS', JSON.stringify(data))
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  updateCarClassOptions({ commit }) {
    return new Promise((resolve, reject) => {
      getCarClassOption({
        hideLoading: true,
        class_id:11
      }).then(res => {
        let { data } = res
        // 處理數據
        // const resultData = handlerOptionsData(data)
        commit(SET_CAR_CLASS_OPTIONS, data)
        sessionStorage.setItem('SET_CAR_CLASS_OPTIONS', JSON.stringify(data))
        resolve(res)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
}

// function handlerOptionsData(data) {
//   let result = {}
//   Object.keys(data).some(key => {
//     if(key == 'currency') {
//       let tempArr = []
//       for(let i = 0; i < data[key].length; i++) {
//         tempArr.push({
//           id: data[key][i],
//           name: data[key][i]
//         })
//       }
//       result[key] = tempArr
//     }
//     else {
//       result[key] = data[key]
//     }
//   })
//   return result
// }

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
